<template>
  <p :class="['text', type, size]"><slot /></p>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      type?: 'regular' | 'medium' | 'bold' | 'underline'
      size?: 'regular' | 'small'
    }>(),
    {
      type: 'regular',
      size: 'regular',
    },
  );
</script>

<style scoped lang="scss">
  .text {
    font-size: remc(16px);
    line-height: remc(24px);

    &.small {
      font-size: remc(14px);
      line-height: remc(20px);
    }

    &.regular {
      font-weight: 400;
    }

    &.medium {
      font-weight: 600;
    }

    &.bold {
      font-weight: 900;
    }

    &.underline {
      font-weight: 600;
      text-decoration: underline;
    }
  }
</style>
